module.exports = __webpack_public_path__ + "img/homeBanner.85395073.jpeg";